export default "__VITE_ASSET__CByQmdiQ__"